import { Auth, onAuthStateChanged } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { useEffect, useRef } from 'react';

// Solution adapted from https://github.com/firebase/firebaseui-web-react/pull/173
interface Props {
    // The Firebase UI Web UI Config object.
    uiConfig: firebaseui.auth.Config;
    // The Firebase App auth instance to use.
    firebaseAuth: Auth; // Use the specific Auth type from firebase/auth
    className?: string;
}

const StyledFirebaseAuth = ({ uiConfig, firebaseAuth, className }: Props) => {
    const elementRef = useRef(null);

    useEffect(() => {
        // Get or Create a firebaseUI instance.
        const firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebaseAuth);

        // The observer is used to reset the widget on sign-out.
        const unregisterAuthObserver = onAuthStateChanged(firebaseAuth, (user) => {
            if (!user) {
                firebaseUiWidget.reset();
            }
        });

        // Render the firebaseUi Widget, but only if the ref is connected.
        console.log(`starting firebase ui with ref ${elementRef.current}`)
        // @ts-ignore
        firebaseUiWidget.start(elementRef.current, uiConfig);

        return () => {
            unregisterAuthObserver();
            firebaseUiWidget.reset();
        };
        // The dependency array is now correct. The effect will only re-run if
        // these props change. This is why memoizing them in the parent is crucial.
    }, [uiConfig, firebaseAuth]);

    return <div className={className} ref={elementRef} />;
};

export default StyledFirebaseAuth;